import React, { useState } from "react";
import { Tabs, Tab, Box } from "@mui/material";
import { InstallationType } from "../components/forms/Pergola_type";
import { ChiusuraChoice } from "../components/side/chiusure_choice";
import { useStoreSelector } from "../../../../../../hooks/StoreHooks";
import { LedChoice } from "../components/side/led_chiusure";

type Side = "front" | "left" | "right" | "back";

const LigthChoices: React.FC = () => {
  const [side, setSide] = useState<Side>("front");
  const pergolaConfiguration = useStoreSelector(store => store.pergolaConfigurationBuilder);
  const addossamento = pergolaConfiguration.configuration?.dimensioni.installazione;
  const handleChange = (_: React.SyntheticEvent, newValue: Side) => {
    setSide(newValue);
  };

  const tabStyle = {
    flexDirection: "column",
    textTransform: "none",
    p: 1.5,
    minWidth: 80,
    border: "1px solid transparent",
    borderRadius: "8px 8px 0 0",
    bgcolor: "transparent",
    transition: "0.3s",
    "&.Mui-selected": {
      bgcolor: "background.paper",
      borderColor: "primary.main",
      borderBottom: "1px solid white",
    },
  };

  const boxStyles = {
    front: {
      width: 40,
      height: 40,
      border: "1px dashed #999",
      display: "flex",
      alignItems: "flex-end",
      justifyContent: "center",
      position: "relative",
      "& > div": { width: "80%", height: 4, bgcolor: "primary.main" },
    },
    left: {
      width: 40,
      height: 40,
      border: "1px dashed #999",
      display: "flex",
      alignItems: "center",
      justifyContent: "flex-start",
      "& > div": { width: 4, height: "80%", bgcolor: "primary.main" },
    },
    right: {
      width: 40,
      height: 40,
      border: "1px dashed #999",
      display: "flex",
      alignItems: "center",
      justifyContent: "flex-end",
      "& > div": { width: 4, height: "80%", bgcolor: "primary.main" },
    },
    back: {
      width: 40,
      height: 40,
      border: "1px dashed #999",
      display: "flex",
      alignItems: "flex-start",
      justifyContent: "center",
      position: "relative",
      "& > div": { width: "80%", height: 4, bgcolor: "primary.main" },
    },
  };
  
  const sidesMap: Record<Side, JSX.Element> = {
    front: <LedChoice lato="Fronte"/>,
    left: <LedChoice lato='Sinistra'/>,
    right: <LedChoice lato='Destra'/>,
    back: <LedChoice lato='Retro'/>,
  };

  return (
    <Box component='div'>
      <Tabs
        value={side}
        onChange={handleChange}
        variant="scrollable"
        scrollButtons="auto"
        sx={{
          display: "flex",
          gap: 10,
          "& .MuiTabs-indicator": { display: "none" },
        }}
      >
        <Tab
          value="front"
          sx={tabStyle}
          icon={<Box sx={boxStyles.front} component= 'div'><Box component= 'div'/></Box>}
          iconPosition="top"
          label="A"
        />
        <Tab
          value="left"
          sx={tabStyle}
          icon={<Box sx={boxStyles.left} component='div'><Box component= 'div'/></Box>}
          iconPosition="top"
          label="B"
        />
        <Tab
          value="back"
          sx={tabStyle}
          icon={<Box sx={boxStyles.back} component= 'div'><Box component= 'div'/></Box>}
          iconPosition="top"
          label="C"
        />
        <Tab
          value="right"
          sx={tabStyle}
          icon={<Box sx={boxStyles.right} component='div'><Box component= 'div'/></Box>}
          iconPosition="top"
          label="D"
        />
      </Tabs>

      <Box
        sx={{
          border: "1px solid",
          borderColor: "primary.main",
          borderRadius: 2,
          borderTopLeftRadius: 0,
          borderTopRightRadius: 0,
          p: 2,
          mt: "-1px",
        }}
        component = 'div'
      >
        {sidesMap[side]}
      </Box>
    </Box>
  );
};

export default LigthChoices;
